import styled from 'styled-components';
import theme from '../../styles/theme';
import BGQuote from '../../images/jpg/bg-chalk.jpg';

const StFigure = styled.figure`
	margin: 0 auto;

	max-width: ${theme.maxWidth};

	.figcap {
		width: 100%;
		display: flex;
		justify-content:flex-end;

	}
	figcaption {
		display: flex;
		text-align: right;
		/* font-size: calc(${theme.fonttitlesize} / 2.4); */
		font-family: ${theme.fonttitle2};
		font-style: italic;
		background-color: ${theme.redCure};
		padding: 0.5rem;
		margin-top: calc(-${theme.fonttitlesize} / 4);
		position: relative;
		z-index: 2;
		max-width: 50%;
		transform: translateX(5px);
		color: black;

		@media (max-width: 800px) {
			display: block;
		}

		strong {
			/* background-color: ${theme.accent}; */
			color: ${theme.black};
			font-family: ${theme.fonttitle};
			font-size: 3.5rem;
			text-transform: uppercase;
			padding: calc(${theme.fonttitlesize} / 4);
			font-style: normal;
			margin: 0 1rem;
			@media (max-width: 800px) {
				display: block;
				padding: calc(${theme.fonttitlesize} / 6);
			}
		}
	}
`;

const CoreParagraph = styled.div`
	h2 {
		border: 1px solid green;
	}
	a {
		color: ${theme.accent};
		text-decoration: none;
		position: relative;
		&:after {
			content: '';
			border: 1px solid ${theme.accent};
			position: absolute;
			top: 100%;
			left: 0;
			right: 0;
		}
	}
	.smaller {
		font-size: 90%;
		margin-block-start: 0.5rem;
		margin-block-end: 0.5rem;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		line-height: 110%;
	}
`;

const CoreBlock = styled.div`

	.wp-block-separator {
		border-color: ${theme.accent};
		max-width: ${theme.normalWidth};
	}

	h2 {
		position: relative;
		padding-top: 1.5rem;

		&:before {
			/* position: absolute; */
			content: '...';
			color: ${theme.accent};
			position: relative;
			top: -1rem;
			padding-right: 0.5rem;
			/* bottom: -10px;
      left: 0; */
		}
	}
	ul {
		max-width: ${theme.normalWidth};
		margin-left: auto;
		margin-right: auto;
		padding: 0 1rem 0 2rem;
	}

	h2,
	h3,
	h4 {
		max-width: ${theme.normalWidth};
		margin-left: auto;
		margin-right: auto;
		padding: 0 1rem;
		font-family: ${theme.fonttitle3};
	}

	h3 {
		font-size: 1.3rem;
		color: ${theme.accent};
	}

	h4 {
		font-size: 1.1rem;
		color: ${theme.accent};
	}

	blockquote {
		/* border: 3px solid ${theme.accent}; */
		padding: 2rem;
		margin-left: auto;
		margin-right: auto;
		max-width: calc(${theme.normalWidth} + 4rem);
		background: ${'url(' + BGQuote + ')'};
		background-size: cover;


    font-weight: 600;
    /* background-position:  bottom; */
    background-repeat: no-repeat;
    text-align: right;

		@media (max-width: 800px) {
			margin-left: 1rem;
			margin-right: 1rem;
			padding: 0.6rem;
		}

    cite {

		font-size: calc(${theme.fonttitlesize} / 4);
      text-align: left;
      font-weight: 700;
	  color: black;
      font-family: ${theme.fonttitle3};
      margin: auto;
    }
		p {text-align: center;
			font-family: ${theme.fontbody};
			font-size: calc(${theme.fonttitlesize}*0.5);
			line-height: calc(${theme.fonttitlesize});
			font-style: bold;
			strong {
				color: ${theme.blakc};
				font-size: calc(${theme.fonttitlesize} / 1);
			}
		}
	}
`;

const CoreVideo = styled.div`
	max-width: ${theme.maxWidth};
	margin-left: auto;
	margin-right: auto;
	@media (max-width: 800px) {
		margin-left: -1rem;
		margin-right: -1rem;
	}
`;

const CoreVerse = styled.div`
	display: none;
	pre {
		max-width: ${theme.normalWidth};
		margin-left: auto;
		margin-right: auto;
		padding: 0 1rem 0 2rem;
		white-space: pre-wrap;
		word-wrap: break-word;
	}
`;

const CoreVideoEmbed = styled.div``;

const StImage = styled.div`
	&.tall-image{
		max-width: ${theme.normalWidth};
		position: relative;
		align-items: center;
		justify-content: center;
		margin-left: auto;
		margin-right: auto;
	}
`;

const CoreMediaText = styled.div`
	align-items: flex-start;
	@media (max-width: 600px) {
		margin-left: -1rem;
		margin-right: -1rem;
	}
	transform: translate3d(0, 0, 0);
	-webkit-transform: translate3d(0, 0, 0);
	.col1 {
		position: sticky;
		transform: translate3d(0, 0, 0);
		-webkit-transform: translate3d(0, 0, 0);
	}
	.col2 {
		position: relative;
		z-index: 2;
		margin-top: 50vh;
		padding-top: 6rem;
		padding-bottom: 50vh;
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
		&:after {
			content: '';
			background: linear-gradient(transparent, rgba(0, 0, 0, 0.7) 20%);
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: -1;
		}
	}
`;

export { StFigure, CoreBlock, CoreParagraph, CoreVideo, CoreVideoEmbed, CoreMediaText, CoreVerse, StImage };
